import { StyleProps } from "@shared/primitive-components"

export const marginBottom = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(2),
})

export const contentWrap = (props: StyleProps) => ({
  margin: props.theme.spacing(3, 0),
})

export const buttonsWrap = (props: StyleProps) => ({
  margin: props.theme.spacing(5, 0),
})
